<template>
    <div class="sectionNewsArchive">
        <div class="containerWrapper">
            <div class="container">
                <div class="hidden">
                    <h1 class="">News</h1>
                </div>

                <div class="content">
                    <div class="newsContainer">
                        <fade-transition :duration="{enter:500, leave: 10}">
                            <ul v-if="show" class="newsListWrapper">
                                <news-item v-for="news_ in _loadedNews"
                                           :key="news_.name"
                                           :news_="news_"
                                           :src="news_.cover">
                                </news-item>

                                <infinite-loading @infinite="get"
                                                  :distance="1500">
                                    <div slot="no-results" class="ctis-finished-notice">
                                        <span class="finish-text spinner">No more news to display</span>
                                    </div>
                                    <div slot="no-more" class="ctis-finished-notice">
                                        <span class="finish-text spinner">No more news to display</span>
                                    </div>
                                    <div slot="error" slot-scope="{ trigger }" class="ctis-finished-notice">
                                        <a class="finish-text" href="javascript:;" @click="trigger">
                                            Something went wrong, click here to retry
                                        </a>
                                    </div>
                                </infinite-loading>
                            </ul>
                        </fade-transition>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import {mapState, mapGetters, mapActions} from 'vuex'
    import {preloadNewsMixin} from "../mixins/shared";
    import FadeTransition from "vue2-transitions/src/Fade/FadeTransition";
    import {menusMixin} from "../mixins/menus";
    import {menusNames as mn,} from "../constants/menus";

    export default {
        components: {FadeTransition},
        mixins: [preloadNewsMixin, menusMixin],
        data() {
            return {
                show: false,
                loading: false,
                error: null,
                identifier: null,
            }
        },
        computed: {
            ...mapGetters('news', [
                'news',
                '_loadedNews',
            ]),
            ...mapState({
                //news: state => state.news.list,
                page: state => state.news.page,
            }),
        },
        created() {
        },
        mounted() {
            this.setSeo(this.$_getMenuSeo(mn.NEWS))

            console.log('news: mounted', 'page', this.page)

            this.$store.dispatch('news/setNews_', null)

            setTimeout(function () {
                window.dispatchEvent(new CustomEvent('scroll'))
            }, 500)

            this.show = true
        },
        methods: {
            ...mapActions('ui', {
                'setSeo': 'setSeo',
            }),
            async get($state) {
                //debugger
                if (this.loading) {
                    return
                }

                if (this.news && !$state) {
                    return
                }

                this.loading = true

                try {
                    //debugger
                    console.log('news: page ', this.page)
                    await this.$store.dispatch('news/get', {page: this.page, per_page: 5})
                    this.$store.dispatch('news/setPage', this.page + 1)

                    await this.$_preloadNews(this.news)
                    //debugger
                    $state.loaded()

                } catch (error) {
                    //debugger
                    if (error.message === 'no-more') {
                        $state.complete()
                    } else {
                        console.log(error)
                        $state.error()
                    }
                }
                this.loading = false
            },
        }
    }
</script>

<style>
    .finish-text {
        font-size: 14px;
    }

    .ctis-finished-notice {
        margin-bottom: 46px;
    }
</style>
